import styled from "styled-components";
import { Button, ButtonProps } from "@material-ui/core";

export const LabelButton = styled(Button)<ButtonProps & { colour?: string }>`
    color: ${({ colour, theme }) => colour || theme.palette.primary.main};
`;
